import Image from 'next/legacy/image';
import { BodyRegular, H1 } from '@components/atoms/typography';
import { useMarketingCopy } from '@hooks/useMarketingCopy';
import type { MarketingCopyAsset } from '@lib/sanity';

const buildVideoSource = (url: string, startTime: number | undefined): string =>
  startTime !== undefined && startTime > 0 ? `${url}#t=${startTime}` : url;

const ADVERT_ASSET_CLASSES =
  'w-auto h-auto max-w-full max-h-[60vh] lg:max-w-3xl lg:max-h-[500px] xl:max-w-4xl rounded-lg';

const AdvertAsset = ({ asset }: { asset: MarketingCopyAsset }) => {
  if (asset.kind === 'video') {
    return (
      <video
        controls
        loop
        muted
        autoPlay={true}
        preload={'auto'}
        className={ADVERT_ASSET_CLASSES}
        src={buildVideoSource(asset.url, asset.startTime)}
        playsInline
      />
    );
  }

  return (
    <img src={asset.url} alt={asset.alt} className={ADVERT_ASSET_CLASSES} />
  );
};

const VideoAdvert = ({ variant }: { variant: 'image' | 'video' }) => {
  const copy = useMarketingCopy();
  const sectionCopy =
    variant === 'image' ? copy.homepage.advert : copy.videoAdvert;

  return (
    <div className="container mx-auto px-4 md:px-16 pt-6 md:pt-16">
      <div className="pb-16">
        <H1>{sectionCopy?.title}</H1>
        <BodyRegular className="pb-8">{sectionCopy?.subtitle}</BodyRegular>
        <div className={`flex flex-col md:flex-row items-center`}>
          {variant === 'image' ? (
            <div className="px-2 md:px-10">
              <Image
                src={'/images/homepage/micah-2025.webp'}
                alt="Description of tools that are available on Fantasy Football Hub's website"
                height={550}
                width={550}
              />
            </div>
          ) : (
            <AdvertAsset asset={copy.videoAdvert.asset} />
          )}

          <div className="flex items-center pl-8 pt-5 md:pt-0">
            <Image
              src={'/images/squiggle-arrow.svg'}
              width={72}
              height={58}
              className="text-warning-600"
              alt="squiggle-arrow"
            />
            <BodyRegular className="w-36 text-warning-600 pl-3">
              Get a sneak peak of The Hub
            </BodyRegular>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoAdvert;
